import { apiClient } from '@/services/apiClient';
import { AgentDashboardData, AdminDashboardData, ContentManagerDashboardData } from '@/types';

class DashboardService {

  async getAgentDashboard(): Promise<AgentDashboardData> {
    return apiClient.get<AgentDashboardData>('/agent/dashboard');
  }

  async getAdminDashboard(): Promise<AdminDashboardData> {
    return apiClient.get<AdminDashboardData>('/admin/dashboard');
  }

  async getContentManagerDashboard(): Promise<ContentManagerDashboardData> {
    return apiClient.get<ContentManagerDashboardData>('/content-manager/dashboard');
  }
}

export const dashboardService = new DashboardService();